import styled from '@emotion/styled';

export const AdminRolesPermissionsWrapper = styled('div', { label: 'AdminRolesPermissionsWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 0%;
`;

export const AdminRolesTopMenu = styled('div', { label: 'AdminRolesTopMenu' })`
    flex: 0 0 44px;
`;


export const AdminRolesContentWrapper = styled('div', { label: 'AdminRolesContentWrapper' })`
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 0%;
    position: relative;
`;


export const AdminRolesContentLhs = styled('nav', { label: 'AdminRolesContentLhs' })`
    background: #fff;
    display: flex;
    flex-flow: column nowrap;
    flex: 0 0 25%;
    height: 100%;
    padding: 10px;
    width: 25%;
`;

export const AdminRolesContent = styled('div', { label: 'AdminRolesContent' })`
    flex: 1 1 0%;
    margin-left: 5px;
    position: relative;
    width: auto;
    font-size: 0.875rem;
`;

